module.exports = __webpack_public_path__ + "media/public/img/banner-0be5f8c42d0a6ea0d2c1cf285ed868ff.png";